const MyComponent = (props) => {
  try {
    return props.children;
  } catch (error) {
    return <div
      className={'w-100 alert alert-danger'}
    >
      <pre>{error?.message}</pre>
      <pre>{error?.toString()}</pre>
    </div>;
  }
};

export default MyComponent;
